import {gql} from "@apollo/client";

export const updateApplicantAgeVerification = gql`
    mutation UpdateApplicantAgeVerification($ageVerificationInfo: AgeVerificationInfoInputField!) {
        updateApplicant(ageVerificationInfo: $ageVerificationInfo) {
            me {
                anyUser {
                    id
                    email
                }
            }
        }
    }
`;
